import React from 'react'
import css from './style.css'
import { Link } from 'react-router'

const EmptyCart = (props) => {
  return (
    <div className={css.empty}>
      <h1 className={css.title}>Your Selections</h1>
      <img className={css.img} src={require('./img/sidebar_empty_state_diamond.png')} width='80' height='63' />
      <p>
        No jewellery or diamonds<br />have been added yet.
      </p>
      <p>
        Fill out the <Link to='/jewellery'>jewellery questionnaire</Link><br />
        or start a <Link to='/search'>diamond search</Link><br />
        to add items.
      </p>
    </div>
  )
}

export default EmptyCart



// WEBPACK FOOTER //
// ./src/containers/cart/empty-cart.js